// extracted by mini-css-extract-plugin
export default {"primeBoardOptionsWrapper":"PrimeCommunityBoardFilters_primeBoardOptionsWrapper__OHOEZ","primeBoardFilters":"PrimeCommunityBoardFilters_primeBoardFilters__cVdYf"};